import { observable, action, runInAction, makeObservable } from 'mobx';

import { IRelease } from '../models/release.model';
import releaseConnection from '../services/connection/release.connection';
import { getLogger } from '../services/logger.service';

const log = getLogger('ReleasesStore');

const RELEASES_LIMIT = 50;

export class ReleasesStore {
  releases: IRelease[] = [];
  loading = false;

  constructor() {
    makeObservable(this, {
      releases: observable,
      loading: observable,
      getReleases: action,
      setLoading: action
    });
  }

  async getReleases() {
    this.setLoading(true);
    try {
      const {releases} = await releaseConnection.getReleases({limit: RELEASES_LIMIT});
      runInAction(() => {
        this.releases = releases;
      });
    } catch (error) {
      log.e('error getting releases', error);
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }
}

export default new ReleasesStore();
